"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var PreLoader_1 = require("./ui/PreLoader");
var Input_1 = __importDefault(require("./ui/Input"));
var EventDispatcher_1 = __importDefault(require("./framework/EventDispatcher"));
var PageManager_1 = __importDefault(require("./framework/pageManager/PageManager"));
var JSFunctions_1 = __importDefault(require("./libs/JSFunctions"));
var StringFunctions_1 = __importDefault(require("./libs/StringFunctions"));
var PageData_1 = __importDefault(require("./framework/pageManager/PageData"));
var GlobalStorage_1 = __importDefault(require("./libs/GlobalStorage"));
var Encode_1 = __importDefault(require("./libs/Encode"));
var ui = {
    Preloader: PreLoader_1.Preloader,
    Input: Input_1.default
};
exports.ui = ui;
var framework = {
    EventDispatcher: EventDispatcher_1.default,
    PageManager: PageManager_1.default,
    PageData: PageData_1.default,
};
exports.framework = framework;
var libs = {
    JSFunctions: JSFunctions_1.default,
    StringFunctions: StringFunctions_1.default,
    GlobalStorage: GlobalStorage_1.default,
    Encode: Encode_1.default,
};
exports.libs = libs;
//# sourceMappingURL=SaffronCode.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/saffroncodejs/lib/SaffronCode.js
// module id = 0
// module chunks = 0